import { useEffect } from 'react';
import { setThemePreference } from 'services/ThemePreference';

function isEffectiveDark(): boolean {
  const attr = document.documentElement.dataset.theme;
  if (attr === 'dark') return true;
  if (attr === 'light') return false;
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

// ⌘⇧P (mac) / Ctrl+Shift+P (others) — toggle light/dark.
// If currently in system mode, the effective theme is read and we
// switch to the opposite — leaving system mode in the process. To
// return to system, use the settings page or color-token inspector.
const DevKeyboardShortcuts = () => {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      const mod = e.metaKey || e.ctrlKey;
      if (!mod || !e.shiftKey) return;
      if (e.key.toLowerCase() !== 'p') return;
      e.preventDefault();
      setThemePreference(isEffectiveDark() ? 'light' : 'dark');
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return null;
};

export default DevKeyboardShortcuts;
